/**
* Service Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'service-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.service-tabs' ).each( function( key, component ) {
        $( component ).on( 'mouseenter', '.service-tabs__tab', function() {
          const tabs = $( this ).siblings( '.service-tabs__tab' );
          const wrapper = $( this ).closest( '.service-tabs__tabs-wrapper' );
          const wrapperWidth = $( wrapper ).outerWidth();
          const minWidth = 232 / wrapperWidth;
          const minPercentage = minWidth * 100;
          const maxPercentage = 100 - ( minPercentage * tabs.length );

          $( tabs ).each( function( tabKey, tab ) {
            $( tab ).removeClass( 'is-open' );
            gsap.to( tab, {width: minPercentage + '%', duration: 0.5} );
          } );

          $( this ).addClass( 'is-open' );
          gsap.to( this, {width: maxPercentage + '%', duration: 0.5} );
        } );
      } );

      // Get the selected button
      const selectedButton = document.getElementById( 'service-tabs__selected-button' );

      // Ensure the button exists before proceeding
      if ( selectedButton ) {
        // Select all toggle buttons
        const toggleButtons = document.querySelectorAll( '.service-tabs__toggle' );

        // Get the initial SVG and text from the selected button
        const initialChevron = selectedButton.querySelector( 'svg' );
        const initialText = selectedButton.textContent.trim();

        toggleButtons.forEach( ( button ) => {
          button.addEventListener( 'click', () => {
            // Get the category (tab title) from the clicked button
            const category = button.getAttribute( 'data-category' );
            if ( category ) {
              // Update only the text content of the selected button (keep the SVG)
              selectedButton.innerHTML = `${category} `;
              selectedButton.appendChild( initialChevron );
            }
          } );
        } );

        // Check if there's a default active button and set the tab title accordingly
        const defaultActiveButton = document.querySelector( '[data-toggle-is-active]' );
        if ( defaultActiveButton ) {
          const defaultActiveCategory = defaultActiveButton.getAttribute( 'data-category' );
          if ( defaultActiveCategory && selectedButton.textContent.trim() === initialText ) {
            selectedButton.innerHTML = `${defaultActiveCategory} `;
            selectedButton.appendChild( initialChevron );
          }
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-tabs', COMPONENT );
} )( app );
